
















import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import { service } from "@modules/newCommunity/setup";

@Component({
  name: "deduplicationClassDialog",
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM: any = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition = SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop - 15 <= SELECTWRAP_DOM.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
})
export default class deduplicationClassDialog extends Vue {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @Prop({
    default: "",
  })
  participateRepeatedClassId!: any;
  @Prop({
    default: "",
  })
  mode!: string;
  @Prop({
    default: "",
  })
  participateRepeatedClassName!: string;

  private settingClassId: any = "";
  private settingList: any = [];
  private selectLoading = false;
  private selectObj: any = { pageSize: 20, pageNum: 1 };
  private totalPage = 0;
  handleAttrValueFilter(val: any) {
    if (!this.selectLoading) {
      this.selectObj.settingName = val;
      this.selectObj.pageNum = 1;
      this.findSettingList();
    }
    this.$nextTick(() => {
      (this.$refs.settingSelect as any).$el.children[1].children[0].children[0].scrollTop = 0;
    });
  }
  handleLoadmore() {
    if (!this.selectLoading && this.selectObj.pageNum < this.totalPage) {
      this.selectObj.pageNum++;
      this.findSettingList();
    }
  }
  handleFouces() {
    this.handleAttrValueFilter("");
  }
  @Watch("settingList", { deep: true })
  settingListWatcher(newVal: any) {
    if (newVal.some((item: any) => item.id == this.participateRepeatedClassId)) {
      this.settingClassId = Number(this.participateRepeatedClassId);
    }
  }
  findSettingList() {
    this.selectLoading = true;
    service
      .findActivityCommonSettingPage({ ...this.selectObj, settingBusinessType: "MEDICAL_QUESTIONNAIRE_REPEATED_CLASS_ID", activitySource: "MEDICAL_QUESTIONNAIRE_ACTIVITY" })
      .then((res: any) => {
        if (res.code === 200) {
          if (this.selectObj.pageNum !== 1) {
            this.settingList.push(...res.data.rows);
          } else {
            this.settingList = res.data.rows;
          }
          this.totalPage = res.data.totalPage;
          this.selectLoading = false;
        }
      })
      .finally(() => {
        this.selectLoading = false;
      });
  }

  onConfirm() {
    const settingItem = this.settingList.filter((item: any) => item.id == this.settingClassId)[0];
    this.$emit("settingClassChange", settingItem);
    this.visible = false;
  }

  onOpen() {
    this.settingClassId = this.participateRepeatedClassId ? this.participateRepeatedClassName + `（id：${this.participateRepeatedClassId}）` : "";
    if (this.settingList.some((item: any) => item.id == this.participateRepeatedClassId)) {
      this.settingClassId = Number(this.participateRepeatedClassId);
    }
    this.findSettingList();
  }
}
